import React, { Fragment, useState, useEffect } from "react";
import { CellRenderRowData, CellRenderOptions, SubLabel } from "./types/JobMatchDetailTypes";
import SubLabelList from "ps-components/SubLabelList/SubLabelList";
import { Tooltip } from "@mantine/core";

/** custom cell render function used to render the title column for survey job matches in JobMatchGridCreate */
export const SurveyMatchDetails = (rowData: CellRenderRowData, key: string, options: CellRenderOptions): JSX.Element => {
  const jobTitle = rowData.field_job_title || rowData.job_title_default || 'No Title';
  const jobCode = rowData.field_job_code || rowData.job_code_default;
  const cutId = rowData.field_cut_id || rowData.cut_id_default;
  const jobScope = rowData.field_job_scope || rowData.job_scope_default;
  const pubSurveyShortName = rowData.field_pub_survey_short_name || rowData.pub_survey_short_name_default;
  const jobDescription = rowData.field_job_description || rowData.job_description_default;
  const { organizationCode } = options;
  const href = `${window.location.origin}/view/o/${organizationCode}/mp/iframe/merit/merit-admin/survey_lib-3?one_cut_id=${cutId}`;

  const subLabels: SubLabel[] = [];
  if (jobScope && jobScope !== '' && jobScope !== ' ') {
    subLabels.push({ label: '', text: jobScope });
  }

  if (pubSurveyShortName && pubSurveyShortName !== '' && pubSurveyShortName !== ' ') {
    subLabels.push({ label: '', text: pubSurveyShortName });
  }

  return (
    <Fragment>
      <a href={href} target="_blank">
        <Tooltip  maw='80%' multiline transitionProps={{ transition: 'fade-up', duration: 500 }} label={jobDescription} openDelay={350} withArrow disabled={!jobDescription}>
          <span className="default-job-cell__title job_match__title">{jobTitle}</span>
        </Tooltip>  
      </a>
      <span className="default-job-cell__title job_match__code">{jobCode}</span>
      <div className="default-job-cell__list job_match__list">
        <SubLabelList isJobMatch={true} subLabels={subLabels} />
      </div>
    </Fragment>
  );
};